import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./i18n/i18n";        // ✅ IMPORT i18n here

import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
   <I18nextProvider i18n={i18n}> 
    <App />
   </I18nextProvider>
  </BrowserRouter>
);
